import { Product, SelectedTickets } from 'types';
// import { getTicketIds } from 'utils/getTicketIds';
import queryString from 'query-string';

export const redirectToIframe = (
  selectedSession: Product,
  selectedTickets: SelectedTickets[],
  activitySlug: string,
  iframeLocation: string | null,
  sessionsList?: Product[],
) => {
  const sessionIds =
    selectedSession.checkoutKey === 'session' && sessionsList && sessionsList.length > 0
      ? sessionsList.map((selectedTicket) => selectedTicket.checkoutValue)
      : [selectedSession.checkoutValue];

  const params = {
    checkoutKey: selectedSession.checkoutKey,
    ...(selectedSession.checkoutKey !== 'session' && {
      checkoutValue: selectedSession.checkoutValue,
    }),
    iframe_location: iframeLocation,
    ...(selectedSession.checkoutKey === 'session' && {
      sessionIds: sessionIds.toString(),
    }),
  };

  const paramsString = queryString.stringify(params);

  const newWindow = window.open(
    `${window?.location.origin}/activity/${activitySlug}?${paramsString}`,
    '_blank',
    'noopener,noreferrer',
  );

  if (newWindow) newWindow.opener = null;
};

export const redirectToAdpFromIframe = (
  selectedSession: Product,
  activitySlug: string,
  iframeLocation: string | null,
  sessionsList?: Product[],
) => {
  const sessionIds =
    selectedSession.checkoutKey === 'session' && sessionsList && sessionsList.length > 0
      ? sessionsList.map((selectedTicket) => selectedTicket.checkoutValue)
      : [selectedSession.checkoutValue];

  const params = {
    iframe_location: iframeLocation,
    ...(selectedSession.checkoutKey === 'session' && {
      sessionIds: sessionIds.toString(),
    }),
  };

  const paramsString = queryString.stringify(params);

  console.log(`${window?.location.origin}/activity/${activitySlug}?${paramsString}`);

  const newWindow = window.open(
    `${window?.location.origin}/activity/${activitySlug}?${paramsString}`,
    '_blank',
    'noopener,noreferrer',
  );

  if (newWindow) newWindow.opener = null;
};
